import { Ng2StateDeclaration, UIRouterModule } from "@uirouter/angular";
import { NgModule } from "@angular/core";
import { GlobalSearchComponent } from "@webapp/search/components/global-search/global-search.component";

const globalSearch: Ng2StateDeclaration = {
  name: "gh.search.home",
  url: "/",
  component: GlobalSearchComponent,
};

const routes = [globalSearch];

@NgModule({
  imports: [UIRouterModule.forChild({ states: routes })],
  exports: [UIRouterModule],
})
export class SearchRoutingModule {}
